import EDC from '@/components/games/shared/globals';

const backgroundImage = require('@/views/BadgesPage/assets/Background.png');
const titleImage = require('@/views/BadgesPage/assets/Title_Background.png');
const titleText = require('@/views/BadgesPage/assets/Title_Text.png');
const crystal0Image = require('@/views/BadgesPage/assets/Orb_Empty.png');
const crystal1Image = require('@/views/BadgesPage/assets/Orb_1.png');
const crystal2Image = require('@/views/BadgesPage/assets/Orb_3.png');
const crystal3Image = require('@/views/BadgesPage/assets/Orb_2.png');
const crystal4Image = require('@/views/BadgesPage/assets/Orb_4.png');
const labelBoxImage = require('@/views/BadgesPage/assets/Orb_Label_Box.png');
const number0AltImage = require('@/views/BadgesPage/assets/Number_0_ALt.png');
const number0Image = require('@/views/BadgesPage/assets/Number_0.png');
const number1Image = require('@/views/BadgesPage/assets/Number_1.png');
const number2Image = require('@/views/BadgesPage/assets/Number_2.png');
const number3Image = require('@/views/BadgesPage/assets/Number_3.png');
const number4Image = require('@/views/BadgesPage/assets/Number_4.png');
const number5Image = require('@/views/BadgesPage/assets/Number_5.png');
const number6Image = require('@/views/BadgesPage/assets/Number_6.png');
const number7Image = require('@/views/BadgesPage/assets/Number_7.png');
const number8Image = require('@/views/BadgesPage/assets/Number_8.png');
const number9Image = require('@/views/BadgesPage/assets/Number_9.png');
const mathTitleImage = require('@/views/BadgesPage/assets/Orb_Label_Text_Math.png');
const languageTitleImage = require('@/views/BadgesPage/assets/Orb_Label_Text_Language.png');
const logicTitleImage = require('@/views/BadgesPage/assets/Orb_Label_Text_Logic.png');
const generalTitleImage = require('@/views/BadgesPage/assets/Orb_Label_Text_General.png');
const starImage = require('@/views/BadgesPage/assets/Star.png');


/**
 *
 */
EDC.Games.Badges.Scenes.Preloader = function () {};
/**
 *
 */
EDC.Games.Badges.Scenes.Preloader.prototype.create = function () {
  this.load.on('complete', this.onLoadImagesComplete, this);
  this.load.image('background', backgroundImage);
  this.load.image('title', titleImage);
  this.load.image('title-text', titleText);
  this.load.image('crystal-0', crystal0Image);
  this.load.image('crystal-1', crystal1Image);
  this.load.image('crystal-2', crystal2Image);
  this.load.image('crystal-3', crystal3Image);
  this.load.image('crystal-4', crystal4Image);
  this.load.image('label-box', labelBoxImage);

  this.load.image('number-0-alt', number0AltImage);
  this.load.image('number-0', number0Image);
  this.load.image('number-1', number1Image);
  this.load.image('number-2', number2Image);
  this.load.image('number-3', number3Image);
  this.load.image('number-4', number4Image);
  this.load.image('number-5', number5Image);
  this.load.image('number-6', number6Image);
  this.load.image('number-7', number7Image);
  this.load.image('number-8', number8Image);
  this.load.image('number-9', number9Image);

  this.load.image('math-title', mathTitleImage);
  this.load.image('language-title', languageTitleImage);
  this.load.image('logic-title', logicTitleImage);
  this.load.image('general-title', generalTitleImage);

  this.load.image('star', starImage);


  this.load.start();
};
/**
 *
 */
EDC.Games.Badges.Scenes.Preloader.prototype.onLoadImagesComplete = function () {
  this.load.off(this.onLoadImagesComplete, this);
  this.scene.start('TitleIntro-Main');
};

export default EDC.Games.Badges.Scenes.Preloader;
